import Axios from 'axios'
import AmplifyStore from '../store/store';
import Vue from 'vue';
import router from "@/router/router";

Axios.defaults.baseURL= process.env.VUE_APP_ROOT_API;
Axios.interceptors.request.use(async config => {
    await refreshUser();
    //authentication & authorization
    config.headers.Authorization = AmplifyStore.getters.getUser.signInUserSession.idToken.jwtToken;
    config.headers['access-token'] = AmplifyStore.getters.getUser.signInUserSession.accessToken.jwtToken;
    return config;
});

Axios.interceptors.response.use(config => {
   return config;
});

async function refreshUser() {
    try {
        //this will refresh the tokens if they expired
        const currentSession = await Vue.prototype.$Amplify.Auth.currentSession();
        const idTokenExpire = currentSession.getIdToken().getExpiration();

        if(currentSession.idToken.jwtToken !=  AmplifyStore.getters.getUser.signInUserSession.idToken.jwtToken){
            const cognitoUser = await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
            AmplifyStore.commit('setUser', cognitoUser);
            Vue.$log.debug('token had been refreshed, new valid time: ', idTokenExpire);
            return;
        }

        Vue.$log.debug('token is still valid, expire in time: ', idTokenExpire);
    }
    catch (e) {
        Vue.prototype.$Amplify.Auth.signOut()
        AmplifyStore.commit('setUser', null);
        Vue.$log.error('Unable to refresh token, ',e);
        Vue.$router.push({name: 'login', query: { redirect: router.currentRoute.path } })
    }
}

export default {}